
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type CategoryPaginationRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function CategoryPaginationRT(): TemplateResult<CategoryPaginationRTRootProps> {
    return _createElement('div', { 'className': 'cm_loadMore__category' }, [this.SearchResult(function () {
            return _createElement('div', { 'className': 'cm_SearchResult__load-more cm_SearchResult' }, [this.loadMore(function () {
                    return _createElement('div', { 'className': 'cm_loadMore' }, _createElement('div', { 'className': 'cm_load-more' }, this.isNotAllItemsReceived ? [
                        this.isActive ? [this.loading] : null,
                        !this.isActive ? [[this.loadMoreButton(function () {
                                    return _createElement('div', {
                                        'className': 'btn btn-default btn-inverse cm_button cm_button__primary cm_loadMoreButton',
                                        'onClick': this.activate
                                    }, '\n        ', window.Convermax.config?.loadMoreText || _translate(`load_more`, {  nextPageSize : this. nextPageSize  }), '\n      ');
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null
                    ] : null));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'category-load-more',
            items: undefined
        })]);
}
        export const componentNames = ["cm:loadMoreButton","cm:loadMore","cm:SearchResult"]